import React from 'react';
import styled from 'styled-components';

const StyledOldLandingPageVideo = styled.video<{
  isSixteenNineRatio: boolean;
}>`
  width: 100%;
  height: ${({ isSixteenNineRatio }) => (isSixteenNineRatio ? 'auto' : '100%')};
  object-fit: cover;
  top: 50%;
  left: 50%;
  position: absolute;
  border-radius: var(--way-design-borderRadiusDefault);
  object-position: center;
  transform: translate(-50%, -50%);
`;

interface OldLandingPageVideoProps {
  src: string;
  alt: string;
  onLoad: () => void;
  isSixteenNineRatio: boolean;
}

export const OldLandingPageVideo = ({
  src,
  alt,
  onLoad,
  isSixteenNineRatio,
}: OldLandingPageVideoProps) => {
  return (
    <StyledOldLandingPageVideo
      isSixteenNineRatio={isSixteenNineRatio}
      onLoad={onLoad}
      aria-label={alt}
      autoPlay
      muted
      loop
    >
      <source src={src} type="video/mp4" />
    </StyledOldLandingPageVideo>
  );
};
